import * as React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Avviso per quando il CARICAMENTO fallisce.
 *
 * Serve a non far sembrare un guasto di rete un archivio vuoto: senza questo,
 * una pagina che non riesce a leggere i dati mostra "Nessuna polizza. Ottimo."
 * e chi la usa crede che vada tutto bene.
 */
export default function DataStateError({
  titolo = "Non riesco a caricare i dati",
  messaggio = "I dati non sono andati persi: è il collegamento che non ha risposto.",
  onRetry = null,
  azioneSecondaria = null,
  compatto = false,
}) {
  return (
    <div className={compatto ? "text-center py-8 space-y-2" : "text-center py-12 space-y-3"}>
      <AlertCircle className={`mx-auto text-amber-500 ${compatto ? "h-8 w-8" : "h-12 w-12"}`} />
      <p className="font-medium text-foreground">{titolo}</p>
      <p className="text-sm text-muted-foreground">{messaggio}</p>
      {(onRetry || azioneSecondaria) && (
        <div className="flex items-center justify-center gap-2 pt-1">
          {onRetry && (
            <Button onClick={onRetry}>
              <RefreshCw className="h-4 w-4 mr-2" /> Riprova
            </Button>
          )}
          {azioneSecondaria}
        </div>
      )}
    </div>
  );
}

